import { API_URL } from '../constants';
import { apiFetch } from './client';

export const getSessionConversionStats = async (queryParams: any) => {
    const params = new URLSearchParams();
    if (queryParams.createdAt_min) params.append('createdAt_min', queryParams.createdAt_min);
    if (queryParams.createdAt_max) params.append('createdAt_max', queryParams.createdAt_max);
    const res = await apiFetch(`${API_URL}/mockup/stats/logs?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

